import { message } from "antd";
import { toLogin } from "./utils";

const UNAUTHORIZED_CODE = 401;

export function handleServerError(err: any, defaultMessage: string = "") {
  if (err.response?.data?.status === UNAUTHORIZED_CODE) {
    toLogin();
    return;
  }
  const msg = getErrorMessage(err);
  message.error(msg, 3);
  console.error(err);
}

export function getErrorMessage(err: any, defaultMessage: string = "We failed to complete your last action. Please try again after a few seconds or contact us.") {
  let msg = "" as string | null;
  if (!!err.response) {
    msg = !!err.response.data ? err.response.data.message : err.response;
  }
  if (typeof msg !== 'string') {
    msg = null;
  }
  return msg ?? defaultMessage;
}
